"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useLifecycles_1 = require("./useLifecycles");
var useLogger = function (name, props) {
    useLifecycles_1.default(function () { return console.log(name + " mounted"); }, function () { return console.log(name + " un-mounted"); });
    react_1.useEffect(function () {
        console.log(name + " props updated", props);
    });
};
exports.default = useLogger;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useLogger.js
// module id = 1215
// module chunks = 17